import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, FormControlLabel,
} from '@material-ui/core';
import {
  setDownloadConfig,
  setDownloadRequestPopFlg,
  createDownloadFile,
} from '../../actions/TargetAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  DOWNLOAD_VALUE,
} from '../../../common/const';
import styles from './TargetPopDownloadComponent.module.css';
import CustomRadio from '../common/CustomRadio';
/**
   * ダウンロードオプションPOPUP
   */
class TargetPopDownloadComponent extends Component {
  componentDidMount() {
    const { setDownloadConfigAct } = this.props;
    setDownloadConfigAct(DOWNLOAD_VALUE.ALL);
  }

  componentDidUpdate(preProps) {
    const {
      downloadRequestPopFlg,
      setDownloadConfigAct,
    } = this.props;
    if (preProps.downloadRequestPopFlg !== downloadRequestPopFlg
      && !downloadRequestPopFlg) {
      // Popup表示フラグがfalseに変更された場合、ダウンロード対象を初期化
      setDownloadConfigAct(DOWNLOAD_VALUE.ALL);
    }
  }

  /**
   * CSVファイル作成
   */
  onClickCreateDownloadFile = async () => {
    const {
      createDownloadFileAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    await createDownloadFileAct();
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      downloadConfig,
      downloadRequestPopFlg,
      downloadLimitOverFlg,
      downloadLimitOverMessage,
      setDownloadConfigAct,
      setDownloadRequestPopFlgAct,
      tradeInfoCondition,
    } = this.props;

    return (
      downloadRequestPopFlg && (
        <div className={`${styles.targetlistdownload}`}>
          {!downloadLimitOverFlg && (
            <div className={`${styles.contents}`}>
              <div className={`${styles.message}`}>ダウンロードオプションを指定してください。</div>
              <div className={`${styles.condition}`}>
                <div className={`${styles.title}`}>ダウンロードする項目</div>
                <div className={`${styles.row}`}>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="全項目"
                      className={downloadConfig === DOWNLOAD_VALUE.ALL
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadConfig === DOWNLOAD_VALUE.ALL}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.ALL)}
                    />
                  </div>
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="カスタムレイアウト"
                      className={downloadConfig === DOWNLOAD_VALUE.MINIMUM
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadConfig === DOWNLOAD_VALUE.MINIMUM}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.MINIMUM)}
                    />
                  </div>
                  {!(tradeInfoCondition && tradeInfoCondition.length > 0) && (
                  <div className={`${styles.item}`}>
                    <FormControlLabel
                      control={<CustomRadio />}
                      label="TSR企業情報のみ"
                      className={downloadConfig === DOWNLOAD_VALUE.TSR_ONLY
                        ? styles.radiobuttoncheck : styles.radiobutton}
                      checked={downloadConfig === DOWNLOAD_VALUE.TSR_ONLY}
                      onClick={() => setDownloadConfigAct(DOWNLOAD_VALUE.TSR_ONLY)}
                    />
                  </div>
                  )}
                </div>
              </div>
              <div className={`${styles.button}`}>
                <Button
                  variant="contained"
                  className={`${styles.buttoncancel} cancel`}
                  onClick={(() => setDownloadRequestPopFlgAct(false))}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={`${styles.buttonnormal}`}
                  onClick={this.onClickCreateDownloadFile}
                >
                  決定
                </Button>
              </div>
            </div>
          )}
          {downloadLimitOverFlg && (
            <div className={`${styles.limitovercontents}`}>
              <div className={`${styles.conf}`}>
                {downloadLimitOverMessage}
              </div>
              <div className={`${styles.limitoverbutton}`}>
                <Button
                  variant="contained"
                  className={`${styles.downloadLimitOverCancelButton} cancel`}
                  onClick={(() => setDownloadRequestPopFlgAct(false))}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  className={`${styles.downloadLimitOverOkButton}`}
                  onClick={this.onClickCreateDownloadFile}
                >
                  OK
                </Button>
              </div>
            </div>
          )}
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    downloadConfig: state.target.downloadConfig,
    downloadRequestPopFlg: state.target.downloadRequestPopFlg,
    downloadLimitOverFlg: state.target.downloadLimitOverFlg,
    downloadLimitOverMessage: state.target.downloadLimitOverMessage,
    tradeInfoCondition: state.target.tradeInfoCondition,
  }),
  (dispatch) => ({
    setDownloadConfigAct: (str) => dispatch(setDownloadConfig(str)),
    setDownloadRequestPopFlgAct: (bool) => dispatch(setDownloadRequestPopFlg(bool)),
    createDownloadFileAct: () => dispatch(createDownloadFile()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(TargetPopDownloadComponent);
